import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/snail/new/year/index', method: 'GET', params }, { interceptResultCode: false });
};
// 领取奖励
export const getReaward = (data) => {
  return axios({ url: '/snail/new/year/reward', method: 'POST', data }, { interceptResultCode: false });
};
// 问卷
export const answer = (params) => {
  return axios({ url: '/snail/new/year/store', method: 'POST', params }, { interceptResultCode: false });
};

// 免密登录
export const secretFreeLoginApi = (data) => {
  return axios({ url: '/cherry/auth/login', method: 'POST', data }, { interceptResultCode: false });
};

// 数据查询
export const onShow = (data) => {
  return axios({ url: '/snail/new/year/show', method: 'GET', data });
};

// 订单查询
export const onQueryOrderAPI = (params) => {
  return axios({ url: '/game/clock/show', method: 'GET', params }, { interceptResultCode: false });
};

// 退款
export const onRefundAPI = (params) => {
  return axios({ url: '/game/clock/refund', method: 'GET', params });
};

// 获取打卡信息
export const getCardInfoAPI = (params) => {
  return axios({ url: '/game/clock/sing', method: 'GET', params });
};

// codeId查询api
export const wechatInfoAPI = (params) => {
  return axios({ url: '/wechat/info', method: 'GET', params }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/snail/doubleDan/api.js